var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":_vm.userManualUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }